import React from 'react';

export default function CalendarIcon() {
  return (
    <svg
      id="calendar-icon"
      x="0px"
      y="0px"
      viewBox="0 0 20.8 20.8"
      width="24"
      height="24"
    >
      <path
        className="cls-1"
        d="M20.4,1H16.8V.4a.4.4,0,0,0-.8,0V1H14.8V.4a.4.4,0,0,0-.8,0V1H6.8V.4A.4.4,0,1,0,6,.4V1H4.8V.4A.4.4,0,0,0,4,.4V1H.4a.4.4,0,0,0-.4.4v19a.4.4,0,0,0,.4.4h20a.4.4,0,0,0,.4-.4V1.4A.4.4,0,0,0,20.4,1ZM4,1.8v.6a.4.4,0,1,0,.8,0V1.8H6v.6a.4.4,0,1,0,.8,0V1.8H14v.6a.4.4,0,0,0,.8,0V1.8H16v.6a.4.4,0,0,0,.8,0V1.8H20V4H.8V1.8ZM20,20H.8V4.8H20Z"
      />
      <path
       className="cls-1"
        d="M3.15,11.3h.5a.4.4,0,0,0,0-.8h-.5a.4.4,0,0,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M3.15,14.3h.5a.4.4,0,0,0,0-.8h-.5a.4.4,0,0,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M3.15,17.3h.5a.4.4,0,0,0,0-.8h-.5a.4.4,0,0,0,0,.8Z"
      />
      <path
       className="cls-1"
        d="M5.48,11.3H6a.4.4,0,0,0,0-.8h-.5a.4.4,0,0,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M5.48,14.3H6a.4.4,0,1,0,0-.8h-.5a.4.4,0,0,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M5.48,17.3H6a.4.4,0,0,0,0-.8h-.5a.4.4,0,0,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M7.82,8.3h.5a.4.4,0,0,0,0-.8h-.5a.4.4,0,0,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M7.82,11.3h.5a.4.4,0,0,0,0-.8h-.5a.4.4,0,0,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M7.82,14.3h.5a.4.4,0,0,0,0-.8h-.5a.4.4,0,0,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M7.82,17.3h.5a.4.4,0,1,0,0-.8h-.5a.4.4,0,0,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M10.15,8.3h.5a.4.4,0,0,0,0-.8h-.5a.4.4,0,0,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M10.15,11.3h.5a.4.4,0,0,0,0-.8h-.5a.4.4,0,0,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M10.15,14.3h.5a.4.4,0,0,0,0-.8h-.5a.4.4,0,0,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M10.15,17.3h.5a.4.4,0,1,0,0-.8h-.5a.4.4,0,1,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M12.48,8.3H13a.4.4,0,0,0,0-.8h-.5a.4.4,0,0,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M12.48,11.3H13a.4.4,0,0,0,0-.8h-.5a.4.4,0,0,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M12.48,14.3H13a.4.4,0,0,0,0-.8h-.5a.4.4,0,0,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M12.48,17.3H13a.4.4,0,1,0,0-.8h-.5a.4.4,0,1,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M14.82,8.3h.5a.4.4,0,0,0,0-.8h-.5a.4.4,0,0,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M14.82,11.3h.5a.4.4,0,0,0,0-.8h-.5a.4.4,0,0,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M14.82,14.3h.5a.4.4,0,0,0,0-.8h-.5a.4.4,0,0,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M17.15,8.3h.5a.4.4,0,1,0,0-.8h-.5a.4.4,0,1,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M17.15,11.3h.5a.4.4,0,1,0,0-.8h-.5a.4.4,0,1,0,0,.8Z"
      />
      <path
        className="cls-1"
        d="M17.15,14.3h.5a.4.4,0,1,0,0-.8h-.5a.4.4,0,1,0,0,.8Z"
      />
    </svg>
  );
}
